module.exports = __webpack_public_path__ + "static/media/naomi-woods-win.9d36a7d3.jpg";